import { Box, Container } from '@mui/material'

export function RowInspirationGridContainer({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={(theme) => ({ mb: `calc(${theme.spacings.xl} + ${theme.spacings.md})` })}>
      <Container>{children}</Container>
    </Box>
  )
}
